module.exports = __webpack_public_path__ + "static/img/1en.2a1330c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/1en.png
// module id = /sBC
// module chunks = 0